import { CartBrowsingCriteria } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';

export interface ProductLine {
  id: ProductLineId;
  productType: ProductType;
  confirmedPortfolioId: string | null;
  browsingCriteria?: CartBrowsingCriteria;
}

export enum ProductType {
  NEW_SALE = 'NEW_SALE',
  CHANGE_PLAN = 'CHANGE_PLAN',
  CANCEL = 'CANCEL',
  RENEW = 'RENEW',
  DONT_PROVIDE = 'DONT_PROVIDE',
  ADD_BENEFIT = 'ADD_BENEFIT',
}

export enum EnrollType {
  E_STORE_ENROLL = 'E_STORE_ENROLL',
  CONTACT_ME = 'CONTACT_ME',
  BROWSING = 'BROWSING',
}

export interface InputPerformedBy {
  id: string;
  name: string;
}
